<template>
  <model-entry
    :model="model"
    :description-visible="descriptionVisible"
    :permissions="workspace.modelpermissions"
    :disabled="disabled"
    @copy="$emit('copy', $event as Model | LocalModelInfo)"
  />
</template>

<script setup lang="ts">
import ModelEntry from "../workspacemodels/ModelEntry.vue";
import type { LocalModelInfo } from "@/api/DB";
import type { Model } from "@/api/Model";

const {
  model,
  descriptionVisible = true,
  disabled = false,
  workspace
} = defineProps<{
  model: Model | LocalModelInfo;
  descriptionVisible?: boolean;
  disabled?: boolean;
  workspace: {
    modelpermissions: any;
  };
}>();

defineEmits<{
  (event: "copy", model: Model | LocalModelInfo): void;
}>();
</script>
